<template>
  <div
    class="form-cell"
    :class="{
      'form-cell--split': type == 'split',
      'form-cell--button': type == 'button',
      'form-cell--wide': type == 'wide',
    }"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  type?: string;
}>();
</script>

<style lang="scss">
.form-cell {
  flex-basis: 50%;

  &.form-cell--split {
    @include mixins.flex-center($gap: variables.$sizing-sm, $horiz: flex-start);

    .button--tertiary {
      margin-left: auto;
    }
  }

  &.form-cell--button {
    flex-basis: 42px;
    flex-grow: 0;
    flex-shrink: 0;
    padding-top: 20px;
  }

  .form-input--select {
    min-width: 100%;
  }

  &.form-cell--wide {
    flex-basis: 66%;
    flex-shrink: 0;;
  }
}
</style>
